import bloomReach from '../shared/bloomreach';
import categoryTabs from '../search/categorytabs';
import {onDOMContentLoaded} from '../../dom/events';

onDOMContentLoaded(() => {
    categoryTabs.initCategory();
    categoryTabs.initTabs();
    bloomReach.init(document.querySelector('.BRRelatedProducts'), '.br-sf-widget', 4);
});
